import { Input, Typography } from '@material-tailwind/react'
import React from 'react'
import { Controller } from 'react-hook-form'
import Infosvg from '../../svgs/Infosvg'
import { useDarkMode } from '../../../../rdxsga/hooks/common/useDarkMode'
import ErrorMessage from './ErrorMessage'
import Label from './Label'

const ControllerWithText = ({ control, name, label, placeholder, wrapperClass = "", required = false, type = "text", disabledControl = false, disableField = false, color, EndIcon, StartIcon }) => {
    const darkMode = useDarkMode();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue=""
            disabled={disabledControl}
            render={({ field, fieldState }) => (
                <div className={`w-full ${wrapperClass}`}>
                    <Label darkMode={darkMode} label={label} required={required} name={name} err={!!fieldState.error} />
                    <div className="relative w-full min-w-[200px] h-auto">
                        {
                            EndIcon && <div className={`absolute grid py-0 px-1 rounded place-items-center top-2/4 right-3 -translate-y-2/4 ${darkMode ? 'bg-themelight text-white' : 'bg-theme text-white'}`}>
                                <EndIcon />
                            </div>
                        }
                        {
                            StartIcon && <div className={`absolute grid py-0 px-1 place-items-center top-2/4 left-3 -translate-y-2/4 ${darkMode ? 'text-white' : 'text-black'}`}>
                                <StartIcon />
                            </div>
                        }
                        {/* <Input
                            {...field}
                            color={color ?? darkMode ? "white" : "black"}
                            // variant='standard'
                            type={type}
                            label={required ? `${label} *` : label}
                            className={`w-full text-blackbox placeholder:text-[#0000] focus:placeholder:text-[#0004] ${darkMode && 'text-white focus:placeholder:text-[#fff4]'} ${EndIcon && "pe-14"} ${StartIcon && "ps-14"}`}
                            placeholder={placeholder ?? label}
                            error={!!fieldState.error}
                        /> */}
                        <input
                            {...field}
                            id={name}
                            type={type}
                            disabled={disabledControl ? field.disabled : disableField}
                            placeholder={placeholder ?? label}
                            className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-black"} shadow appearance-none border border-theme rounded w-full py-2 px-3 outline-none leading-tight`}
                        />
                    </div>
                    <ErrorMessage fieldState={fieldState} />
                </div>
            )}
        />
    )
}

export default ControllerWithText

// ${ fieldState.error && "border-danger" }